import React from 'react';
import { Typography, Box, styled } from '@mui/material';
import Grid from '../../components/common/Grid';
import { WaterQualityGauge } from '../charts';
import { WaterQualityData } from '../../types/waterQuality';

interface WaterParameterGaugesProps {
  waterData: WaterQualityData;
}

const SectionTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  fontWeight: theme.typography.fontWeightMedium,
}));

const GaugeWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
}));

export const WaterParameterGauges: React.FC<WaterParameterGaugesProps> = ({ waterData }) => {  return (
    <Box sx={{ mb: 4 }}>
      <SectionTitle variant="h6">Key Water Parameters</SectionTitle>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', margin: '-8px' }}>
        <Box sx={{ width: { xs: '100%', sm: '50%', md: '33.33%' }, padding: '8px' }}>
          <GaugeWrapper>
            <WaterQualityGauge
              title="pH"
              value={waterData.ph}
              min={4.0}
              max={9.0}
              optimalStart={5.5}
              optimalEnd={6.5}
              colors={{
                belowOptimal: '#e74c3c', // Red for too acidic
                optimal: '#2ecc71',       // Green for optimal
                aboveOptimal: '#f39c12',  // Orange for too alkaline
              }}
            />
          </GaugeWrapper>
        </Box>
        
        <Box sx={{ width: { xs: '100%', sm: '50%', md: '33.33%' }, padding: '8px' }}>
          <GaugeWrapper>
            <WaterQualityGauge
              title="EC"
              value={waterData.ec}
              min={0.0}
              max={3.0}
              optimalStart={0.2}
              optimalEnd={1.0}
              unit="mS/cm"
              colors={{
                belowOptimal: '#f39c12', // Orange for too low
                optimal: '#2ecc71',      // Green for optimal
                aboveOptimal: '#e74c3c', // Red for too high
              }}
            />
          </GaugeWrapper>
        </Box>
        
        <Box sx={{ width: { xs: '100%', sm: '50%', md: '33.33%' }, padding: '8px' }}>
          <GaugeWrapper>
            <WaterQualityGauge
              title="Alkalinity"
              value={waterData.alkalinity}
              min={0.0}
              max={300.0}
              optimalStart={80.0}
              optimalEnd={120.0}
              unit="mg/L"
              colors={{
                belowOptimal: '#f39c12', // Orange for too low
                optimal: '#2ecc71',      // Green for optimal
                aboveOptimal: '#e74c3c', // Red for too high
              }}
            />
          </GaugeWrapper>
        </Box>
      </Box>
    </Box>
  );
};

export default WaterParameterGauges;
